import React, { memo } from 'react'
import Card from '../Card/Card.jsx'
import Pagination from '../Pagination/Pagination.jsx'

const Cards = memo(({ restaurants, view, requestCounter }) => {

  if ( !restaurants.length && requestCounter > 0 ) {
    return (
      <div className="c-searchCards--noResults">
        <p>Oops, we don’t seem to have that search. Please try another.</p>
      </div>
    )
  }

  return (
    <div className="c-searchCards">
      <Pagination type="top" />
      <div className="c-searchCards__row row">
        {
          restaurants && (
            restaurants.map( ( restaurant, index ) => <Card key={restaurant.id} restaurant={restaurant} view={view} /> )
          )
        }
      </div>
      <Pagination type="bottom" />
    </div>
  )
})

export default Cards